import { SMH } from '@/renderer/scripts/smh';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { IS_BROWSER } from '@/common/constant/platform';
import storage from '@/renderer/scripts/utils/storage';
import store from '@/renderer/store';
import router from '@/renderer/router';
import { DrawerEvents } from '@/renderer/store/modules/drawer';

/**
 * @description 打开文件夹/打开源目录
 * @param
 * item--数据项;
 * isOpenFolder--是否打开文件夹（true为打开文件夹，false为打开源目录）
 * targetRouteName--需要跳转的路由
 * currentRouteName--当前所在路由
 * @export
 */
export function openFolderOrDirectory(params: {
  item: SMH.SpaceFileItemData | SMH.SearchFileData | any;
  isOpenFolder: boolean;
  targetRouteName?: string;
  currentRouteName?: string;
}) {
  const { item, isOpenFolder, targetRouteName, currentRouteName } = params;
  // 路由跳转name
  let routerName = '';
  // 路由跳转所需参数
  let routeQuerys = {};
  // 路由跳转path路径
  let pathArr: any[] = [];
  if (isOpenFolder) {
    pathArr = item.path.slice(0);
  } else {
    // 跳转到源目录，路径要length-1
    pathArr = item.path.slice(0, -1);
  }
  switch (item.spaceTag) {
    case 'personal':
      routeQuerys = {
        path: pathArr.join('/'),
      };
      routerName = 'personalSpace';
      break;
    case 'team':
      {
        // 需额外判断原因: 搜索处后端返回的path为string类型
        const teamPath =
          typeof item.team.path === 'string' ? item.team.path : item.team.path?.join('/') || item.team.name;
        routeQuerys = {
          spaceId: item.spaceId,
          teamId: String(item.team.id),
          teamPath,
          path: pathArr.join('/'),
        };
        routerName = 'teamSpace';
      }
      break;
    case 'group': {
      const isExternal = item.group.orgId !== store.getters.orgId;
      routeQuerys = {
        spaceId: item.spaceId,
        id: String(item.group.id),
        name: item.group.name,
        spaceOrgId: String(item.group.orgId) || store.getters.orgId,
        path: pathArr.join('/'),
        isExternal: `${+isExternal}`,
      };
      store.commit(DrawerEvents.SET_SELECTEDLIST, [
        {
          ...item.group,
          ownerId: item.group.userId,
        },
      ]);
      routerName = 'collaborationSpaceList';
    }
    default:
      break;
  }
  routerName = targetRouteName ? targetRouteName : routerName;
  // 跳我的收藏二级目录 ｜ 与我相关二级目录需crumbStartIndex
  if (['favoriteList', 'relatedToMeFileList'].includes(routerName)) {
    storage.set(storage.StoreKey.RECV_SHARE_SPACE, {
      crumbStartIndex: pathArr.length,
      spaceId: item.spaceId,
    });
    Object.assign(routeQuerys, {
      spaceTag: item.spaceTag || '',
      spaceId: item.spaceId,
      startIndex: pathArr.length,
    });
  }
  if (currentRouteName === 'search') {
    Object.assign(routeQuerys, {
      fromRoute: 'search',
    });
  }
  if (isOpenFolder && currentRouteName !== 'search') {
    dispatchRouter({ name: routerName, query: routeQuerys });
  } else {
    // 跳源目录是先判断是否属于本空间：是-直接跳转，否-跳与我相关
    if (item.isUserBelongSpace) {
      // 文件审批页web端需打开一个新的窗口
      if (currentRouteName === 'fileApply' && IS_BROWSER) {
        const newpage = router.resolve({
          path: routerName,
          query: routeQuerys,
        });
        dispatchRouter(newpage?.href, '_blank');
      } else {
        dispatchRouter({ name: routerName, query: routeQuerys });
      }
    } else if (item.relatedToMePath) {
      const relatedPath = item.relatedToMePath.slice(0, -1);
      if (relatedPath.length === 0) {
        // web页面打开源目录是打开一个新窗口
        if (currentRouteName === 'fileApply' && IS_BROWSER) {
          const newpage = router.resolve({
            path: 'relatedToMe',
            query: routeQuerys,
          });
          dispatchRouter(newpage?.href, '_blank');
        } else {
          dispatchRouter({ name: 'relatedToMe' });
        }
      } else {
        storage.set(storage.StoreKey.RECV_SHARE_SPACE, {
          crumbStartIndex: pathArr.length,
          spaceId: item.spaceId,
        });
        Object.assign(routeQuerys, {
          spaceTag: item.spaceTag || '',
          spaceId: item.spaceId,
          startIndex: pathArr.length,
        });
        if (currentRouteName === 'fileApply' && IS_BROWSER) {
          const newpage = router.resolve({
            path: 'relatedToMeFileList',
            query: routeQuerys,
          });
          dispatchRouter(newpage?.href, '_blank');
        } else {
          dispatchRouter({
            name: 'relatedToMeFileList',
            query: routeQuerys,
            params: { isCospace: String(item.spaceTag === 'group') },
          });
        }
      }
    }
  }
}
